/** Пункт «Візуальна модель закону» лівого меню конструктора законопроєктів (прототип v4 mnLawModel). Чисті функції. */
import { routes } from '@platform/core/lib/routes';
import { isLawTab, LAW_TABS } from '../tabs/lawdesigner/lawTabs';
import type { IMenuLink } from './IMenuLink';

/** Ключ сторінки модуля «Візуальна модель закону». */
export const LAW_MODEL_PAGE = 'lawmodel';

/**
 * На сторінці запису головного типу `rtKey` пункт веде на «Структуру» цього запису й активний лише з вкладкою конструктора в адресі — коли
 * запис відкрито через цей пункт, сторінку моделі, перемикач чернетки чи клік по вкладці конструктора (прототип: cur — state.tab «lz_…»;
 * запис зі списку показує «Структуру» за замовчуванням, але пункт не підсвічено); деінде — на сторінку модуля `lawmodel` (вона відкриває
 * перший запис) без примусового стану. Інші посилання — без змін.
 */
export function lawModelLinkOf(link: IMenuLink, moduleKey: string, rtKey: string, route: { rt?: string; id?: string; tab?: string }): IMenuLink {
  if (link.key !== LAW_MODEL_PAGE || route.rt !== rtKey || !route.id) return link;
  return { ...link, to: routes.record(moduleKey, rtKey, route.id, LAW_TABS[0]), active: isLawTab(route.tab) };
}
